module.exports = __webpack_public_path__ + "img/comentariu-la-gramica-lui-teodor-1768-pagina-de-titlu-big.2deeeaba.jpg";